function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFilled550X550Px = function SvgFilled550X550Px(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 758.2 745.7",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m411 9.3 338.9 352.8c11.5 11.9 10.9 30.8-1.2 42.1L390 737.5c-12.1 11.3-31.3 10.7-42.8-1.2L8.3 383.5c-11.5-11.9-10.9-30.8 1.2-42.1L368.2 8.1C380.4-3.2 399.5-2.6 411 9.3",
    style: {
      fill: "#e2001a"
    }
  }));
};
export default SvgFilled550X550Px;